import { useState, useSyncExternalStore } from "react";
import { getReadFailures, resetReadFailures, subscribeReadFailures } from "../lib/readFailures";

export const ReadFailureBoundary = ({ scope, children }) => {
  const failures = useSyncExternalStore(subscribeReadFailures, getReadFailures);
  const [attempt, setAttempt] = useState(0);
  const failed = [...failures.values()].some(value => value.scope === scope);
  return <>
    {failed && <section role="alert" data-testid="page-read-error" className="page-read-error">
      <h2>We couldn’t load this view completely</h2>
      <p>Figures and actions are hidden to avoid showing incomplete information as zero or “all caught up”. Your connection may recover automatically.</p>
      <button data-testid="page-read-retry" className="btn btn-primary" onClick={() => { resetReadFailures(scope); setAttempt(value => value + 1); }}>Reload this view</button>
      <p className="text-sm">Reloading the view resets any unsaved entries on this page.</p>
    </section>}
    <div key={attempt} hidden={failed} aria-hidden={failed ? true : undefined} className="page-read-content">{children}</div>
  </>;
};